<template>
  <div>
    <div class="tableDiv">
      <div class="timeDiv">
        年月：<el-date-picker v-model="sbsj" type="month" value-format="yyyy-MM" placeholder="选择年月"></el-date-picker>
      </div>
      <div class="titleDiv"><span>{{ this.sbsj }} 各大队管理业绩考核指标基础项(30分)</span></div>
      <el-table :data="data" border highlight-current-row style="width: 96%">
        <el-table-column v-if="hideIdColumn" prop="id" label="ID"></el-table-column>
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column prop="bmmc" label="大队" width="180" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.bmid" placeholder="请选择大队" @change="getGdXX(scope.row.bmid)">
              <el-option v-for="item in depts" :key="item.bmid" :label="item.bmmc" :value="item.bmid"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="jcsj" label="检查时间" width="260" align="center">
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.jcsj"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column prop="gd" label="岗点" width="220" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.gdid" filterable placeholder="请选择岗点">
              <el-option
                v-for="item in gdDatas"
                :key="item.gdid"
                :label="item.gdmc"
                :value="item.gdid">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="dy" label="队员" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.dy" placeholder="请输入队员姓名"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="kpnr" label="考评内容" width="260" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.kpnr" filterable placeholder="请选择" @change="knprChange(scope.row)">
              <el-option
                v-for="item in khnrDatas"
                :key="item.id"
                :label="item.kpnr"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="kf" label="扣分" width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.kf" placeholder="请输入扣分" :disabled="!isDfNull"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="filePath" label="附件" width="230" align="center">
          <template slot-scope="scope">
            <el-upload
              class="upload-demo"
              action=""
              :on-preview="handlePreview"
              :on-remove="(file, fileList) => handleRemove(file, fileList, scope.$index)"
              :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, scope.$index)"
              :on-change="(file, fileList) => handleFileChange(file, fileList, scope.$index)"
              :file-list="scope.row.fileList"
              list-type="text"
              :limit="1"
              :auto-upload="false">
              <el-button size="small" type="primary">点击上传</el-button>
              <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
            </el-upload>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-button type="primary" @click="addRow">新增一行</el-button>
        <el-button type="primary" round class="floating-button1" :disabled="handleSaveButton" @click="handleSave">保存</el-button>
        <el-button type="primary" round class="floating-button2" :disabled="releaseButton" @click="release">发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      rawData: [],
      sbsj: '',
      depts: [],
      bmid: '',
      bmmc: '',
      jcsj:'',
      gdDatas: [],
      khnrDatas: [],
      hideIdColumn :false,
      handleSaveButton: false,
      releaseButton: false,
      isDfNull: false,
      kknrMap: new Map(),
    };
  },
  created() {
    this.getDepts();
    this.getKhnrn();
  },
  methods: {
    // 获取部门数据
    getDepts() {
      this.$request({
        method: 'get',
        url: '/bjba/khxx/xjxx/findDdData'
      }).then((response) => {
        if (response.data.code === 200) {
          this.rawData = response.data.data;
          this.processData();
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    processData() {
      this.depts = this.rawData.map(item => {
        let newItem = {};
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            newItem[key.toLowerCase()] = item[key];
          }
        }
        return newItem;
      });
    },
    //获取岗点信息
    getGdXX(val){
      console.log('选中的值为==',val)
      this.$request.get('/bjba/khxx/baqw/findGdxxByBmId',{
                    params: {bmid:val}
                }).then(res => {
                  this.gdDatas = res.data.data
                })
    },
    //获取考核信息
    getKhnrn(){
      this.$request.get('/bjba/khxx/baqw/findKpnrData').then(res => {
                  this.khnrDatas = res.data.data.map(item => {
                                  let newItem = {};
                                  for (let key in item) {
                                    if (item.hasOwnProperty(key)) {
                                      newItem[key.toLowerCase()] = item[key];
                                    }
                                  }
                                  return newItem;
                                });
                   this.khnrDatas.forEach(item => {
                      this.kknrMap.set(item.id, item.kf); // 假设接口返回的数据有id和kf两个属性
                   });
                      
                  })
    },
    //考评内容触发事件
    knprChange(row){
      
      //根据选中的内容扣除相应的分数
      let df = this.kknrMap.get(row.kpnr);
      console.log("考评内容为==", df)
      if(df === undefined || df === null){
        this.isDfNull = true;
      }else {
        this.isDfNull = false;
        row.kf = df; // 根据考评内容更新扣分
      }
    },
  
    // 发布
    release() {
          if(this.sbsj == '' || this.sbsj==undefined){
              this.$message({
                              message: '请选择时间',
                              type: 'error',
                              duration: 1500
                          })
              return 
          }
          this.$confirm('是否已保存？需先保存后发布，发布后不可更改')
          .then(_ => {
              this.$request.get('/bjba/khxx/fzhs/release',{
                  params: {bbsj:this.sbsj}
              }).then(res => {
                  if(res.data.code === 200){
                      this.handleSaveButton = true
                      this.releaseButton = true
                      this.$message({
                              message: res.data.message,
                              type: 'success',
                              duration: 1500
                          })
                      window.close();
                  }else {
                      this.$message({
                              message: res.data.message,
                              type: 'error',
                              duration: 1500
                          })
                  }
              })
          })
          .catch(_ => {});

    },
    //保存
    handleSave() {
                if(this.sbsj == '' || this.sbsj==undefined){
                    this.$message({
                                    message: '请选择时间',
                                    type: 'error',
                                    duration: 1500
                                })
                    return 
                }
                console.log('data=====',this.data)
                this.data[0].bbjs =  this.sbsj
                this.$http({
                            url: `/bjba/khxx/fzhs/saveFzhs`,
                            method: 'post',
                            data: this.data
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: data.message,
                                    type: 'success',
                                    duration: 1500
                                })
                            } else {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })
            },
    // 添加行
    addRow() {
      this.isDfNull = false
      this.data.push({
        bmid: '',
        bmmc: '',
        jcsj: '',
        gd: '',
        dy: '',
        kpnr: '',
        kf: '',
        fileList: [] // 每行的文件列表
      });
    },
    handleRemove(file, fileList, index) {
      this.data[index].fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleSuccess(response, file, fileList, index) {
      // 成功上传后，将文件信息保存到对应行的数据中
      this.data[index].fileList = fileList;
    },
    handleFileChange(file, fileList, index) {
      // 覆盖之前的文件
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.data[index].fileList = fileList;
    },
    submitUpload() {
        this.$refs.upload.submit();
    },
  },
};
</script>

<style>
.tableDiv {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.titleDiv {
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}

el-table {
  width: 100%;
}

.timeDiv {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: bold;
}

.floating-button1 {
  position: fixed;
  bottom: 100px; /* 距离底部20px */
  right: 3%;  /* 距离右侧20px */
  padding: 10px 20px;
  background-color: #8bc516;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000; /* 确保按钮在所有内容之上 */
}

.floating-button1:hover {
  background-color: #0056b3;
}

.floating-button2 {
  position: fixed;
  bottom: 50px; /* 距离底部20px */
  right: 3%;  /* 距离右侧20px */
  padding: 10px 20px;
  background-color: #1482b5;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  z-index: 1000; /* 确保按钮在所有内容之上 */
}

.floating-button2:hover {
  background-color: #0e90ad;
}
</style>
